import { getV1, postV1 } from '@/common/utils/ajax'
import { DEFAULT_PER } from '@/config'
import { mapHouseItem } from '@/common/utils/map_view_data'
const list = (options) => {
    Object.keys(options).forEach((key) => {
        if (!options[key]) {
            delete options[key]
        }
    })
    return getV1('seek_buildings', {
        per: DEFAULT_PER,
        ...options
    }).then((res) => {
        res.items = res.items.map(mapHouseItem)
        return res
    })
}

const seek_buildings = (options) => {
    return getV1('seek_buildings', options).then((res) => {
        res.items = res.items.map(mapHouseItem)
        return res
    })
}

const map_zones = (params) => {
    return getV1('map_zones', params)
}

const map_zone_sections = (params) => {
    return getV1('map_zone_sections', params)
}

const map_buildings = (params) => {
    return getV1('map_buildings', params)
}

const notificate = (params) => {
    return postV1('building_seeking_demands', params)
}

const hot_subjects = () => {
    return getV1('hot_subjects')
}

const hot_subject = (id) => {
    return getV1(`hot_subjects/${id}`)
}


const hot_subjects_articles = (hot_subject_id, option) => {
    return getV1(`hot_subject_articles`, {
        ...option,
        hot_subject_id,
        per: 10
    } )
}

const hot_subjects_article = (id) => {
    return getV1(`hot_subject_articles/${id}`)
}

const getNcov2019 = () => {
    return getV1('ncov2019_communities')
}

const getMetroStations = (line, status = '') => {
    const params = {}
    if (line) {
        params.line = line
    }
    if (status) {
        params.status = status
    }
    return getV1('metro_stations', params)
}
const getRecommendedBuildings = (data) => {
    return getV1('recommended_buildings', data).then((data) => {
        data.items = data.items.map(mapHouseItem)
        return data
    })
}

export default {
    list,
    seek_buildings,
    map_zones,
    map_zone_sections,
    map_buildings,
    notificate,
    hot_subjects,
    hot_subjects_articles,
    hot_subject,
    hot_subjects_article,
    getNcov2019,
    getMetroStations,
    getRecommendedBuildings
}
